import React, { memo } from 'react';
import SessionsLoader from '../../../../../../core/components/campaigns/campaigndetails/sessionsTabV2/SessionsLoaderV2';
import SessionsController from '../../../../../../core/components/campaigns/campaigndetails/sessionsTabV2/SessionsControllerV2';
import SessionsTabView from './SessionsTabView';

const SessionsTab = ({ ...props }) => {
  return (
    <SessionsLoader {...props}>
      <SessionsController {...props}>
        <SessionsTabView {...props} />
      </SessionsController>
    </SessionsLoader>
  );
};

export default memo(SessionsTab);
